<app-new-modal [showModal]="showError" title="ERROR" primaryButtonText="BACK" width="50%" (primaryAction)="goHome()"
	hideClose="true">
	<div style="margin-block: 40px;font-size: 18px;font-weight: 400;">
		{{ "SOMETHING_WENT_WRONG" | translate }}
	</div>
</app-new-modal>

<section>
	<div class="row page-title">
		<div class="container clear-padding text-center flight-title">
			<h3 style="margin-top: 40px;">
				Redirection en cours...
			</h3>
		</div>
	</div>
</section>

<div class="" style="width: full;height: 80dvh; display: flex;align-items: center;justify-content: center;">
	<div class="loader"></div>
</div>